
















import { PageModeMixin } from '@/main/mixins/pageMode';
import { showAlert } from '@/main/utils/notifications';

import { EmailEdit } from './state';
import { apiProvider } from './api';

export default PageModeMixin.extend({
	name: 'VerifyEmailModal',
	props: {
		visible: { type: Boolean, required: true },
		emailModel: { type: Object },
	},
	data() {
		return {
			emailState: new EmailEdit(),
			loading: false,
			error: false,
		};
	},
	computed: {
		visibleCmp: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			},
		},
		modalLabel(): string {
			return this.LocalizePopisPoli('VERIFY_EMAIL');
		},
		disableOk(): boolean {
			return this.error;
		},
		validationRules(): { emailState: Record<string, any> } {
			return {
				emailState: this.emailState.ValidationRules!,
			};
		},
		validator(): Function {
			return (this.$children[0].$refs.modalForm as any).validate;
		},
	},
	methods: {
		closeModal() {
			this.visibleCmp = false;
		},
		async sendEmail() {
			const isValid = await this.validate();
			if (!isValid) {
				return;
			}
			this.emailModel.TestEmailAddress = this.emailState.To;
			this.emailModel.IsTestEmail = true;
			const formData: FormData = new FormData();
			formData.append('msgLogEmail', JSON.stringify(this.emailModel));
			this.loading = true;
			const { data: result } = await apiProvider.sendEmail(formData);
			this.visibleCmp = false;
			if (!result) {
				const message = this.LocalizeChyboveHlasky('DMS_EMAILFAILURE');
				this.showErrorNotification(message);
				return;
			}
			showAlert({
				message: this.LocalizeChyboveHlasky('DMS_EMAILSUCESS'),
				title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
				options: {
					type: 'info',
				},
			});
		},
		async validate() {
			let isValid;
			this.validator((valid: boolean) => {
				isValid = valid;

				valid || this.showErrorAlert({ message: 'InvalidForm' });
			});
			return isValid;
		},
	},
	watch: {
		visible(visibleValue: boolean) {
			this.emailState = new EmailEdit();
			this.error = false;
			this.loading = false;
		},
	},
});
